
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DebitPaymentFailureReasons, PaymentError } from '@/interfaces/payment-options';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import { broadcast } from '@/events/eventBus';
import events from '@/events/Events';

@Component({ components: { CustomButton } })
export default class PaymentErrorMessage extends Vue {
  @Prop({ required: true, type: Object }) readonly error!: PaymentError;

  get loanNumber(): string {
    return this.$store.getters['User/activeLoanNumber'];
  }

  get hasMultipleLoans(): boolean {
    return this.$store.getters['User/availableLoans'].length > 1;
  }

  get hasBankAccount(): boolean {
    return this.$store.getters['PaymentOptions/bankAccountIsVerified'];
  }

  get canUpdateCard(): boolean {
    return this.error.reason === DebitPaymentFailureReasons.TRANSACTION_NOT_ALLOWED;
  }

  get canRetry(): boolean {
    return this.error.reason === DebitPaymentFailureReasons.INSUFFICIENT_FUNDS
      || this.error.reason === DebitPaymentFailureReasons.OTHER;
  }

  addBank() {
    broadcast(events.PAYMENT_SETTINGS.EDIT_BANK);
    this.clear();
  }

  updateCard() {
    broadcast(events.PAYMENT_SETTINGS.EDIT_CARD);
    this.clear();
  }

  retryPayment() {
    this.$emit('retry', 'card');
    this.clear();
  }

  retryUsingBank() {
    this.$emit('retry', 'bank');
    this.clear();
  }

  clear() {
    this.$emit('cleared');
  }
}
